<template>
  <slot
    :toggle="favoriteToggle"
    :loading="loading"
    :is-favorite="isFavorite"
  >
    <div @click="favoriteToggle">
      <wui-icon
        :name="loading ? 'spinner' : isFavorite ? 'starF' : 'starEmptyM'"
        class="text-surf-brand-base-def"
      />
      <p class="text-label-r-13-18 text-center text-surf-brand-base-def">
        {{ $t('mainAside.favorites') }}
      </p>
    </div>
  </slot>
</template>

<script setup lang="ts">
import { useRenderNotifier, WuiIcon } from '@wui/common-library'
import { ref } from 'vue'

import { useContact } from '@/entities/use-contact'

import { useLocalization } from '@/shared/composables/localization'
import { Contact } from '@/shared/types/api'

const props = defineProps<{
  contact: Contact
}>()

const { isFavorite, toggleFavorite } = useContact(props.contact)
const { t } = useLocalization()
const { notifyError } = useRenderNotifier()
const loading = ref(false)

const favoriteToggle = async () => {
  try {
    loading.value = true
    await toggleFavorite()
  } catch (e: unknown) {
    const errorMessage = e instanceof Error ? e.message : t('common.unknownError')
    notifyError(errorMessage)
  } finally {
    loading.value = false
  }
}
</script>
